export enum RegionAuthorization {
    None = "None",
    Us = "Us",
    SouthAmerica = "SouthAmerica",
    Brazil = "Brazil",
    Mexico = "Mexico",
    Canada = "Canada",
}
